import React, {useContext, useEffect} from 'react';
import {CookieConsentContext} from '../../../../utils/cookiesUtil';

const useGoogleTag = () => {
  const {cookieConsent} = useContext(CookieConsentContext);

  useEffect(() => {
    if (cookieConsent?.analytical && cookieConsent?.marketing) {
      const {head} = document;

      const scripts = [];
      for (let i = 0; i < 4; ++i) {
        scripts.push(document.createElement('script'));
      }

      scripts[0].async = true;
      scripts[0].src = 'https://www.googletagmanager.com/gtag/js?id=UA-86989574-1';

      scripts[1].async = true;
      scripts[1].src = 'https://www.googletagmanager.com/gtag/js?id=G-415Z29XWDH';

      scripts[2].textContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-415Z29XWDH');
      `;

      scripts[3].textContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-86989574-1');
      `;

      const start = document.createComment('Google tag (gtag.js)');
      const end = document.createComment('END Google');

      const elements = [start, ...scripts, end];
      head.prepend(...elements);
    }
  }, []);

  return <></>;
};

export default useGoogleTag;
